module.exports = __webpack_public_path__ + "img/attendance_5.6fbdf4b1.png";